import { render, staticRenderFns } from "./Observaciones.vue?vue&type=template&id=b883fbd4&scoped=true&"
import script from "./Observaciones.vue?vue&type=script&lang=js&"
export * from "./Observaciones.vue?vue&type=script&lang=js&"
import style0 from "./Observaciones.vue?vue&type=style&index=0&id=b883fbd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b883fbd4",
  null
  
)

export default component.exports